import { render } from "./LabelSizes.vue?vue&type=template&id=ab9f9c0e&scoped=true&ts=true"
import script from "./LabelSizes.vue?vue&type=script&lang=ts"
export * from "./LabelSizes.vue?vue&type=script&lang=ts"

import "./LabelSizes.vue?vue&type=style&index=0&id=ab9f9c0e&scoped=true&lang=css"

import exportComponent from "/home3/sli/web/public/resources/editorvue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab9f9c0e"]])

export default __exports__